import { useState } from 'react';
import Linkify from 'linkify-react';
import { ShowMore } from '@re-dev/react-truncate';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NoSsr from '@mui/material/NoSsr';
import Typography from '@mui/material/Typography';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

const renderLink = ({ attributes, content }) => (
  <Link className="link" target="_blank" rel="noopener" href={attributes.href}>
    {content}
  </Link>
);

export function ShowMoreLessText({ text, onClick, lines = 2, typography = 'caption', sx }) {
  const { t } = useTranslate();

  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const renderFallback = () => (
    <Stack sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <Typography
        variant={typography}
        sx={[
          (theme) =>
            !expanded && {
              ...theme.mixins.maxLine({ line: lines }),
            },
        ]}
      >
        {text}
      </Typography>
    </Stack>
  );

  return (
    <NoSsr fallback={renderFallback()}>
      <Stack sx={[...(Array.isArray(sx) ? sx : [sx])]}>
        <Typography component="div" variant={typography}>
          <ShowMore
            lines={lines}
            trimWhitespace
            expanded={expanded}
            onClick={() => {
              setExpanded(!expanded);
              onClick?.(!expanded);
            }}
            more={
              <>
                ...
                <Box component="span" className="show__more__less__button" sx={{ typography }}>
                  {t('more')}
                </Box>
              </>
            }
            less={
              <Box
                component="span"
                className="show__more__less__button"
                onClick={() => {
                  setExpanded(false);
                  onClick?.(false);
                }}
                sx={{ typography }}
              >
                {t('less')}
              </Box>
            }
          >
            <Linkify options={{ render: renderLink }}>{text}</Linkify>
          </ShowMore>
        </Typography>
      </Stack>
    </NoSsr>
  );
}
